import { CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSettlementPayeeQuickInfoMulticompany extends Layout {
    citystatePayee: CityState;
    panelCarrierInfo: Panel;
    panelQuickInfo: Panel;
    sourceDrsPayeeMulticompany: DataSource;
    textboxDotNumber: Textbox;
    textboxDrsPayeepayMethod: Textbox;
    textboxDrsPayeetypeOf: Textbox;
    textboxIccNumber: Textbox;
    textboxId: Textbox;
    textboxIntrastateCode: Textbox;
    textboxPaymentMethod: Textbox;
    textboxPhoneNumber: Textbox;
}
